<template>
  <div class="room-label" @click.stop="onClickHandler" :class="classes">
    <div class="room-label__wrap">
      <div class="room-label__teams">
        <div class="member">
          <div class="member__ava member__ava_red">
            <img
              v-if="match.player1 && match.player1.avatar"
              :src="match.player1.avatar"
              alt="avatar"
            />
            <SvgIcon v-else size="80%" name="user-light" />
          </div>
        </div>
        <div class="room-label__teams__result">
          <span class="result-empty"
            ><SvgIcon :size="small ? 16 : 22" name="close"
          /></span>
        </div>
        <div class="member">
          <div class="member__ava member__ava_blue">
            <img
              v-if="match.player2 && match.player2.avatar"
              :src="match.player2.avatar"
              alt="avatar"
            />
            <SvgIcon v-else size="80%" name="user-light" />
          </div>
        </div>
      </div>
      <div class="room-label__text">
        Комната матча
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    match: {
      type: Object,
      required: true
    },

    small: Boolean
  },

  computed: {
    classes() {
      return {
        "room-label_small": this.small
      };
    }
  },

  methods: {
    onClickHandler() {
      const href = this.$router.resolve({
        name: "tournament-match",
        params: {
          tournament_id: this.match.tournament_id,
          match_id: this.match.id
        }
      }).href;

      this.$emit("clicked", href);
    }
  }
};
</script>

<style lang="scss">
.room-label {
  position: relative;
  border-radius: 100%;
  background: gradient(#fbc33e, #e72f31);
  box-shadow: 0 0 30px rgba(#e72f31, 0.75);
  animation: room-label-pulse 1s infinite;
  overflow: hidden;
  user-select: none;
  cursor: pointer;

  width: 320px;
  height: 320px;
  padding: 10px;

  &:before {
    content: "";
    position: absolute;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  @include breakpoint("xs-only") {
    width: 255px;
    height: 255px;
  }

  &__wrap {
    position: relative;
    border-radius: inherit;
    border: 4px solid #e72f31;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      144.17px at 50% 51.82%,
      #8d1111 0%,
      #1e2135 100%
    );

    &:before {
      content: "";
      position: absolute;
      border-radius: inherit;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: url("~@/assets/img/match-ready-bg.png") no-repeat center
        center #1e2135;
      transition: 0.2s;

      .room-label:hover & {
        // transform: scale(0.95);
        box-shadow: inset 0 0 10px 0 #000;
      }

      .room-label:active & {
        // transform: scale(0.9);
        box-shadow: inset 0 0 30px 0 #000;
      }
    }
  }

  &__teams {
    position: relative;
    top: 20%;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: center bottom;
    transition: 0.2s;

    .room-label:hover & {
      transform: scale(0.95);
    }

    .room-label:active & {
      transform: scale(0.9);
    }

    .member {
      background: none;
      padding: 0;
      margin: 0;

      &__ava {
        margin: 0;
        min-width: 52px;
        max-width: 52px;
        height: 52px;
        border: 2px solid;

        display: flex;
        align-items: center;
        justify-content: center;

        img,
        svg {
          display: block;
          width: 100%;
        }

        svg {
          margin: 0;
          width: 80%;
        }

        .btn__content {
          justify-content: center;
        }

        &_red {
          background: #811314;
          border-color: #e72f31;
          color: rgba(#e72f31, 0.8);
        }

        &_blue {
          background: #0d5577;
          border-color: #1480b2;
          color: rgba(#1480b2, 0.8);
        }
      }
    }

    &__result {
      color: #fbc33e;
      padding: 0 30px;

      @include breakpoint("xs-only") {
        padding: 0 16px;
      }
    }
  }

  &__text {
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: 50px;
    line-height: 48px;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    color: #fbc33e;
    text-shadow: 0px 6px 8px rgba(0, 0, 0, 1);
    transform-origin: center top;
    transition: 0.2s;

    .room-label:hover & {
      transform: scale(0.95);
    }

    .room-label:active & {
      transform: scale(0.9);
    }

    top: 28%;
    left: 0;
    width: 100%;

    @include breakpoint("xs-only") {
      font-size: 38px;
      line-height: 36px;
    }
  }

  &_small {
    width: 160px;
    height: 160px;
    padding: 5px;

    &.room-label {
      animation: room-label-small-pulse 1s infinite;
    }

    .room-label__wrap {
      border: 2px solid #e72f31;

      &:before {
        background-size: 160px 160px;
      }
    }

    .room-label__teams {
      .member {
        &__ava {
          min-width: 26px;
          max-width: 26px;
          height: 26px;
        }
      }

      &__result {
        color: #fbc33e;
        padding: 0 12px;

        @include breakpoint("xs-only") {
          padding: 0 12px;
        }
      }
    }

    .room-label__text {
      font-size: 25px;
      line-height: 24px;

      @include breakpoint("xs-only") {
        font-size: 25px;
        line-height: 24px;
      }
    }
  }
}
</style>
